import layout from '../../styles/layout.module.css'
import Head from 'next/head'
import Container from 'react-bootstrap/Container'
import { useTranslation } from 'next-i18next'
import { GetStaticProps } from 'src/var/next/next'
import { withNamespace } from '../../src/util/src/i18next'
import { getTranslations } from 'src/var/next/next-i18next'
import guides from '../../styles/guides.module.css'
import Col from 'react-bootstrap/Col'
import { allGames } from '../../src/PlayToEarn/data/allGames'
import Row from 'react-bootstrap/Row'
import { GameCard } from '../../components/GameCard'

export default function PlayToEarnGames(props: Props) {
  // const { } = props

  const { t } = useTranslation(translationNamespaces)
  const tc = withNamespace(t, 'common')
  const title = t('title')
  const description = t('description')

  return (
    <Container className={layout.main}>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
      </Head>
      <h1 className={guides.instructionSubheader}>{title}</h1>
      <hr />
      {/* <p>{description}</p> */}
      <Container>
        <Row xs={1} md={2} lg={3}>
          {allGames.map(game => (
            <Col key={game.id} className="g-3">
              <GameCard game={game} />
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  )
}

interface Props {

}

// const ParamsSchema = z.object({
//   username: UsernameSchema,
// })

export const getStaticProps: GetStaticProps = async (context) => {
  const { locale, params } = context
  const translations = await getTranslations(context, translationNamespaces)
  return {
    props: {
      ...translations,
    },
  }
}

const translationNamespaces = ['play-to-earn-games', 'play-to-earn', 'common']
